let AP: any = null;
// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
	// @atlaskit/simple-xdm/plugin is an ES-module default export, so when loaded via require(), we need to read `.default` (otherwise we get the module namespace object)
	const requiredAP = require('@atlaskit/simple-xdm/plugin');
	AP = requiredAP?.default ?? requiredAP;
}

export function requireModule<Module>(name: string): Module | null | undefined {
	if (!AP) {
		return null;
	}

	let requiredModule: Module | null | undefined;

	try {
		AP.require(name, (module: Module) => {
			requiredModule = module;
		});
	} catch {
		requiredModule = null;
	}

	return requiredModule;
}
